import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  Tabs,
  Spin,
  DatePicker,
  Modal,
  Form,
  Checkbox,
  Tooltip,
  Input,
  Select,
  notification,
  Radio,
  AutoComplete,
  Upload,
  message,
} from "antd";
import Config from "../../config";
import axios from "axios";
//import PlusIcon from "./PlusIcon.png";
import dayjs from "dayjs";
//import CrossIcon from "./Cross.svg";
//import AddIncident from "./AddIncident.svg";
import moment from "moment";
import DeleteImg from "../../components/images/DeleteImg.svg";
import AddIconBlue from "../images/AddIconBlue.svg";
import AddAttachment from "./CreateTicket/AddAttachmentModel/AddAttachment";
import { read, utils } from "xlsx";
import { saveAs } from "file-saver";
//import "./Incidents.css";
//import Message from "./Message.svg";
//import AddNew from "./AddNew.svg";
const { TextArea } = Input;
const { Option } = Select;

export default class Attachment extends Component {
  state = {
    attachmentStatus: false,
    attachmentArray: [],
    months: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    isModalVisible: false,
    isDeleteModalVisible: false,
    AttachmentIDToBeDeleted: null,
    showDocument: false,
    ticketID: 1,
    createdBy: "",
    fileList: [],
    isAttachmentView: false,
    attachmentData: null,
    attachmentDataFileType: null,
    attachmentDataFileName: null,
    fileContent: null,
    fileContentXLS: null,
  };

  componentDidMount() {
    this.fetchAttachmentDetails();
  }

  fetchAttachmentDetails = () => {
    const ticketID = this.props.TicketID;
    const token = "generated_token"; // Replace 'generated_token' with the actual generated token

    axios
      .get(`${Config.Ticket}/GetAttachmentsByTicketID?TicketID=${ticketID}`, {
        headers: {
          Authorization: sessionStorage.getItem("access_token"),
        },
      })
      .then((response) => {
        console.log("new", response);
        // Handle the response data here
        this.setState({
          attachmentArray: response.data,
          attachmentStatus: false,
          createdBy: response.data.UploadedBy,
        });
        console.log("rrr22", this.state.attachmentArray);
      })
      .catch((error) => {
        // Handle errors here
        console.error(error);
      });
  };
  //==========================
  showModal = () => {
    // setIsModalVisible(true);
    this.setState({
      isModalVisible: true,
      fileList: [],
    });
  };

  handleModalClose = () => {
    // setIsModalVisible(false);
    this.setState({
      isModalVisible: false,
    });
  };

  handleTicketIDChange = (e) => {
    // setTicketID(e.target.value);
    this.setState({
      ticketID: e.target.value,
    });
  };

  handleCreatedByChange = (e) => {
    // setCreatedBy(e.target.value);
    this.setState({
      createdBy: e.target.value,
    });
  };

  handleFileListChange = (info) => {
    //setFileList(info.fileList);
    this.setState({
      fileList: info.fileList,
    });
    console.log("files", this.state.fileList);
  };

  // handleUpload = () => {
  //   // console.log("clickkkk")
  //   const allowedFormats = [".pdf", ".docx", ".xls", ".csv", ".txt", ".jpg", ".jpeg", ".png",];
  //   const maxFileSize = 25 * 1024 * 1024;

  //   const formData = new FormData();
  //   formData.append("TicketID", this.props.TicketID);
  //   formData.append("CreatedBy", this.props.CreatedBy);
  //   this.state.fileList.forEach((file, index) => {
  //     formData.append(`File${index + 1}`, file.originFileObj);
  //   });

  //   axios
  //     .post(`${Config.Ticket}/AddAttachmentByTicketID`, formData, {
  //       headers: {
  //         Authorization: sessionStorage.getItem("access_token"),
  //         "Content-Type": "multipart/form-data",
  //       },
  //     })
  //     .then((response) => {
  //       // Handle success response
  //       message.success("Attachment(s) added successfully");
  //       // setIsModalVisible(false);
  //       this.setState({
  //         isModalVisible: false,
  //       });
  //       this.fetchAttachmentDetails();
  //     })
  //     .catch((error) => {
  //       // Handle error response
  //       console.error(error);
  //       message.error("Failed to add attachment(s)");
  //     });
  //   // await this.fetchAttachmentDetails()
  // };

  handleUpload = () => {
    const allowedFormats = [
      ".pdf",
      ".docx",
      ".xls",
      ".csv",
      ".txt",
      ".jpg",
      ".jpeg",
      ".png",
    ];
    const maxFileSize = 25 * 1024 * 1024;
    const maxAttachments = 5;

    if (this.state.fileList.length === 0) {
      message.error("Please select a file to upload.");
      return;
    }

    if (this.state.fileList.length > maxAttachments) {
      message.error("You can only upload up to 5 attachments.");
      return;
    }

    const formData = new FormData();
    formData.append("TicketID", this.props.TicketID);
    formData.append("CreatedBy", this.props.CreatedBy);
    formData.append("CreatedByUsername", sessionStorage.getItem("userName"));

    for (let i = 0; i < this.state.fileList.length; i++) {
      const file = this.state.fileList[i];

      if (
        !allowedFormats.includes(file.name.slice(file.name.lastIndexOf(".")))
      ) {
        message.error(
          "Attached file format is not supported. Please upload a file with .PDF, .DOCX, .XLS, .CSV, .TXT, .JPG, .JPEG, or .PNG extension only."
        );
        return;
      }

      if (file.size > maxFileSize) {
        message.error(
          "Attached document exceeds the allowed limit. File size should be below or equal to 25MB."
        );
        return;
      }

      formData.append(`File${i + 1}`, file.originFileObj);
    }

    axios
      .post(`${Config.Ticket}/AddAttachmentByTicketID`, formData, {
        headers: {
          Authorization: sessionStorage.getItem("access_token"),
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        // Handle success response
        message.success("Attachment(s) added successfully");
        this.setState({
          isModalVisible: false,
        });
        this.fetchAttachmentDetails();
      })
      .catch((error) => {
        // Handle error response
        console.error(error);
        message.error("Failed to add attachment(s)");
      });
  };

  viewAttachment = (val) => {
    console.log("view", val);
    if (val.FileType === ".png") {
      this.downloadPNGData(val);
    } else if (val.FileType === ".docx") {
      this.downloadDOCXData(val);
    } else {
      this.setState({
        isAttachmentView: true,
      });
      this.fetchAttachmentData(val);
    }
  };

  handleModalViewClose = () => {
    //setIsModalVisible(false);
    this.setState({
      isAttachmentView: false,
      attachmentData: null,
      attachmentDataFileType: "",
      attachmentDataFileName: "",
      fileContent: "",
      fileContentXLS: "",
    });
  };

  fetchAttachmentData = (str) => {
    console.log("val in doc:", str);

    // const path =
    //   "C:/PM_Document/Dev/TicketAttachments/MicrosoftTeams_image_(2)_Apr_10_2023_13_12_27.png";
    // const fileName = "MicrosoftTeams-image (2).png";
    // const fileType = ".png";
    const path = str.FilePath;
    const fileName = str.FileName;
    const fileType = str.FileType;

    axios
      .get(`${Config.Ticket}/GetAttachmentByKey`, {
        headers: {
          Authorization: sessionStorage.getItem("access_token"),
        },
        params: {
          Path: path,
          FileName: fileName,
          FileType: fileType,
        },
        responseType: "arraybuffer",
      })
      .then((response) => {
        // const text = new TextDecoder().decode(response);
        console.log("rrnew", new TextDecoder().decode(response.data));
        const FileContent = new TextDecoder().decode(response.data);
        const file = new Blob([response.data], {
          type: "application/pdf",
        });
        const fileUrl = URL.createObjectURL(file);

        const workbook = read(response.data, { type: "array" });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const html = utils.sheet_to_html(worksheet);
        this.setState({
          attachmentData: fileUrl,
          attachmentDataFileType: response.config.params.FileType,
          attachmentDataFileName: response.config.params.FileName,
          fileContent: FileContent,
          fileContentXLS: html,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  };
  downloadDOCXData = (str) => {
    
    const path = str.FilePath;
    const fileName = str.FileName;
    const fileType = str.FileType;
    
    axios
      .get(`${Config.Ticket}/GetAttachmentByKey`, {
        headers: {
          Authorization: sessionStorage.getItem("access_token"),
        },
        params: {
          Path: path,
          FileName: fileName,
          FileType: fileType,
        },
        responseType: "blob", // Set the responseType to "blob" to receive the file as a blob
      })
      .then((response) => {
        if (fileType === ".docx") {
          const file = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document" });
          const fileUrl = URL.createObjectURL(file);
          const link = document.createElement("a");
          link.href = fileUrl;
          link.download = fileName;
          link.click();
        } else {
          // Handle other file types
          const FileContent = new TextDecoder().decode(response.data);
          const file = new Blob([response.data], { type: "application/pdf" });
          const fileUrl = URL.createObjectURL(file);
  
          const workbook = read(response.data, { type: "array" });
          const worksheet = workbook.Sheets[workbook.SheetNames[0]];
          const html = utils.sheet_to_html(worksheet);
          this.setState({
            attachmentData: fileUrl,
            attachmentDataFileType: response.config.params.FileType,
            attachmentDataFileName: response.config.params.FileName,
            fileContent: FileContent,
            fileContentXLS: html,
          });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
  downloadPNGData = (str) => {
    
    const path = str.FilePath;
    const fileName = str.FileName;
    const fileType = str.FileType;
    
    axios
      .get(`${Config.Ticket}/GetAttachmentByKey`, {
        headers: {
          Authorization: sessionStorage.getItem("access_token"),
        },
        params: {
          Path: path,
          FileName: fileName,
          FileType: fileType,
        },
        responseType: "arraybuffer",
      })
      .then((response) => {
        const file = new Blob([response.data], { type: "image/png" });
        const fileUrl = URL.createObjectURL(file);
  
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = fileName;
        link.click();
      })
      .catch((error) => {
        console.error(error);
      });
  };
  
  deleteAttachment = (item) => {
    console.log("del", item);
    const url = `${Config.Ticket}/DeleteAttachment`;

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: sessionStorage.getItem("access_token"),
      },
      body: JSON.stringify({
        AttachmentID: this.state.AttachmentIDToBeDeleted,
        DeletedBy: sessionStorage.getItem("userEmail"),
        DeletedByUsername: sessionStorage.getItem("userName"),
      }),
    };

    fetch(url, requestOptions)
      .then((response) => {
        if (response.status === 200) {
          // Call the fetchAttachmentDetails function
          this.fetchAttachmentDetails();
          this.setState({
            isDeleteModalVisible: false,
          });
        }
        return response.json();
      })
      .then((data) => {
        // Handle the response data here
        console.log(data);
      })
      .catch((error) => {
        // Handle the error here
        console.error("Error:", error);
      });
  };
  deleteModal = (item) => {
    this.setState({
      isDeleteModalVisible: true,
      AttachmentIDToBeDeleted: item,
    });
  };
  handleDeleteCancel = () => {
    this.setState({
      isDeleteModalVisible: false,
    });
  };
  handleDeleteYes = () => {
    this.deleteAttachment();
    // this.setState({
    //   isDeleteModalVisible: false,
    // });
  };

  handleDownload = () => {
    const link = document.createElement("a");
    link.href = this.state.attachmentData;
    link.download = this.state.attachmentDataFileName;
    link.click();
  };

  //==========================
  render() {
    const isPNG =
      this.state.attachmentDataFileType == ".jpg" ||
      this.state.attachmentDataFileType == ".jpeg" ||
      this.state.attachmentDataFileType == ".png";
    return (
      // <div>Attachment</div>
      <div>
        <div className="">
          {this.state.attachmentStatus === false ? (
            <div>
              {this.state.attachmentArray.length != 0 && (
                <div>
                  <div className="fieldBackground">
                    <div className="incidentFlex addBorder">
                      <div className="addIncident">
                        Total Attachments :{" "}
                        {this.state.attachmentArray.length < 10
                          ? "0" + this.state.attachmentArray.length
                          : this.state.attachmentArray.length}
                      </div>
                      <div className="ml-4">
                        <button
                          type="button"
                          className="cancle-button px-3 my-3"
                          onClick={this.showModal}
                        >
                          <img
                            className="mr-2"
                            src={AddIconBlue}
                            style={{ height: "15px", width: "15px" }}
                          />
                          <b>Add Attachment</b>
                        </button>
                      </div>
                    </div>
                    <div
                      className="attachmentTableDiv tableMarginLeftPadding"
                      style={{ marginTop: "0px" }}
                    >
                      <table
                        className="attachmentTable incidentdummyTable1"
                        style={{ width: "100%" }}
                      >
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Attachment Name</th>
                            <th>Added By</th>
                            <th>Added On</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody className="tableBody">
                          {this.state.attachmentArray.length != 0 &&
                            this.state.attachmentArray.map((item, index) => {
                              if (index <= 8) {
                                var serialNumber = "0" + (index + 1);
                              } else {
                                var serialNumber = index + 1;
                              }

                              const month = new Date(
                                item.UploadedDate
                              ).getMonth();
                              const date = new Date(
                                item.UploadedDate
                              ).getDate();
                              const year = new Date(
                                item.UploadedDate
                              ).getFullYear();
                              return (
                                <tr>
                                  <td>{serialNumber}</td>
                                  <Tooltip title={item.FileName}>
                                    <td>
                                      <a
                                        className="pathColor"
                                        onClick={() =>
                                          this.viewAttachment(item)
                                        }
                                      >
                                        {item.FileName}
                                      </a>{" "}
                                    </td>
                                  </Tooltip>
                                  <Tooltip title={item.UploadedByUsername}>
                                    <td>{item.UploadedByUsername}</td>
                                  </Tooltip>
                                  <td>
                                    {this.state.months[month]} {date}, {year},{" "}
                                    {item.UploadedTime.slice(0, 5)}
                                  </td>
                                  <td>
                                    <img
                                      src={DeleteImg}
                                      //   onClick={() =>
                                      //     this.showModal(item, "attachments")
                                      //   }
                                      onClick={() =>
                                        //this.deleteAttachment(item.AttachmentID)
                                        this.deleteModal(item.AttachmentID)
                                      }
                                      style={{
                                        width: "11px",
                                        height: "15px",
                                        cursor: "pointer",
                                      }}
                                      alt="delete"
                                    />
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <Modal
                    title="Are you sure to Delete?"
                    open={this.state.isDeleteModalVisible}
                    closable={false}
                    footer={[
                      <Button key="cancel" onClick={this.handleDeleteCancel}>
                        Cancel
                      </Button>,
                      <Button
                        key="delete"
                        type="danger"
                        style={{
                          backgroundColor: "#DC3545",
                          borderColor: "#DC3545",
                          color: "#ffffff",
                        }}
                        onClick={this.handleDeleteYes}
                      >
                        Yes, Delete
                      </Button>,
                    ]}
                  >
                    <p>This will discard information permanently!</p>
                  </Modal>

                  <Modal
                    title="Add Attachment"
                    open={this.state.isModalVisible}
                    onCancel={this.handleModalClose}
                    maskClosable={false}
                    footer={[
                      <Button key="cancel" onClick={this.handleModalClose}>
                        Cancel
                      </Button>,
                      <Button
                        key="upload"
                        type="primary"
                        onClick={this.handleUpload}
                      >
                        Upload
                      </Button>,
                    ]}
                  >
                    <div>
                      {/* <label>Ticket ID:</label>
          <input type="number" value={this.state.ticketID} onChange={this.handleTicketIDChange} />

          <label>Created By:</label>
          <input type="text" value={this.state.createdBy} onChange={this.handleCreatedByChange} /> */}

                      <label style={{ fontWeight: "600" }}>
                        Attachment Upload
                      </label>
                      <br />

                      <Upload
                        fileList={this.state.fileList}
                        beforeUpload={() => false}
                        onChange={this.handleFileListChange}
                      >
                        {this.state.fileList.length < 5 && (
                          <Button style={{ textDecoration: "underline" }}>
                            <u>Add Attachment</u>
                          </Button>
                        )}
                      </Upload>
                    </div>
                  </Modal>
                  <Modal
                    title={
                      <div className="documentPreview">Document Preview</div>
                    }
                    open={this.state.isAttachmentView}
                    onCancel={this.handleModalViewClose}
                    maskClosable={false}
                    footer={null}
                    destroyOnClose={true}
                    centered={true}
                    width={920}
                    style={{ marginTop: "-75px" }}
                  >
                    {this.state.attachmentData ? (
                      <div className="PreviewContainer">
                        {/* <img
                          src={this.state.attachmentData}
                          alt="Attachment"
                          style={{ maxWidth: "70%" }}
                        />
                        <Button type="primary" onClick={this.handleDownload}>
                          Download
                        </Button> */}
                        {this.state.attachmentDataFileType !== ".pdf" && (
                          <Button type="primary" onClick={this.handleDownload}>
                            Download
                          </Button>
                        )}

                        <div className="DocPrev">
                          {/* for pdf below */}
                          {this.state.attachmentDataFileType == ".pdf" && (
                            <iframe
                              src={this.state.attachmentData}
                              height="100%"
                              width="100%"
                              style={{ border: "0" }}
                            />
                          )}
                          {/* for heading as file name */}
                          {this.state.attachmentDataFileType !== ".pdf" && (
                            <h6>{this.state.attachmentDataFileName}</h6>
                          )}
                          {/* for image below */}
                          {isPNG && (
                            <img
                              src={this.state.attachmentData}
                              alt="Image"
                              height="90%"
                              width="100%"
                              style={{ border: "0" }}
                            />
                          )}
                          {/* for txt below TXT*/}
                          {this.state.attachmentDataFileType == ".txt" && (
                            <pre
                              style={{
                                maxHeight: "370px",
                                overflow: "auto",
                                whiteSpace: "pre-wrap",
                                marginTop: "20px",
                              }}
                            >
                              {this.state.fileContent}
                            </pre>
                          )}
                          {/* for excel below XLS and CSV*/}
                          {(this.state.attachmentDataFileType == ".csv" ||
                            this.state.attachmentDataFileType == ".xlsx" ||
                            this.state.attachmentDataFileType == ".xls") && (
                            <iframe
                              srcDoc={this.state.fileContentXLS}
                              title="Excel Preview"
                              height="98%"
                              width="100%"
                            />
                          )}
                        </div>
                      </div>
                    ) : (
                      <div>Loading attachment...</div>
                    )}
                  </Modal>
                </div>
              )}
              {this.state.attachmentArray.length === 0 && (
                <div className="fieldBackground borderAlignment">
                  <div className="imageAlignment ">
                    <div className="fitImage d-flex justify-content-center">
                      <div>
                        <div className="addCenter">
                          <button
                            className="addIncidentButton"
                            onClick={this.showModal}
                          >
                            Add
                          </button>
                        </div>
                        <div className="addIncidentText">
                          First Attachment For This Ticket
                        </div>
                      </div>
                    </div>
                  </div>
                  <Modal
                    title="Add Attachment"
                    open={this.state.isModalVisible}
                    onCancel={this.handleModalClose}
                    maskClosable={false}
                    footer={[
                      <Button key="cancel" onClick={this.handleModalClose}>
                        Cancel
                      </Button>,
                      <Button
                        key="upload"
                        type="primary"
                        onClick={this.handleUpload}
                      >
                        Upload
                      </Button>,
                    ]}
                  >
                    <div>
                      {/* <label>Ticket ID:</label>
          <input type="number" value={this.state.ticketID} onChange={this.handleTicketIDChange} />

          <label>Created By:</label>
          <input type="text" value={this.state.createdBy} onChange={this.handleCreatedByChange} /> */}

                      <label style={{ fontWeight: "600" }}>
                        Attachment Upload
                      </label>
                      <br />
                      <Upload
                        fileList={this.state.fileList}
                        beforeUpload={() => false}
                        onChange={this.handleFileListChange}
                      >
                        <Button style={{ textDecoration: "underline" }}>
                          <u>Add Attachment</u>
                        </Button>
                      </Upload>
                    </div>
                  </Modal>
                </div>
              )}
            </div>
          ) : (
            <div>No Data</div>
          )}
        </div>
      </div>
    );
  }
}
